import React from 'react';
export function OpeningHook() {
  return <section className="bg-off-white py-20 px-4" data-id="element-120">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-121">
        <p className="text-xl md:text-2xl font-serif leading-relaxed text-near-black" data-id="element-122">
          Es lunes por la mañana. Te miras al espejo y sientes que tu cuerpo no
          te pertenece. La cara hinchada, los ojos cansados y ese vientre que
          hace que tus pantalones favoritos se sientan como una tortura.
        </p>
        <p className="text-lg font-sans text-gray-700 leading-relaxed" data-id="element-123">
          No has ganado 3 kilos de grasa en un fin de semana; estás sufriendo un{' '}
          <strong className="text-dark-green font-semibold" data-id="element-124">
            "secuestro hídrico"
          </strong>{' '}
          por estrés.
        </p>
        <div className="w-16 h-px bg-sage mx-auto my-8" data-id="element-125"></div>
        <p className="text-lg font-sans text-gray-700 leading-relaxed" data-id="element-126">
          Tu cuerpo ha activado la señal de alarma y ha decidido retener cada
          mililitro de agua para protegerse. No necesitas más cardio ni comer
          menos.{' '}
          <span className="italic" data-id="element-127">Necesitas apagar el incendio interno.</span>
        </p>
      </div>
    </section>;
}